import { useEffect, useState, useRef, useMemo } from 'react';
import { useParams } from 'react-router';
import DataTables from '../../CommonDataTable/DataTable';
import RolePermissions from '../../CommonModals/Permissions';
import useCurrentScreenDataContext from '../../../../hooks/useCurrentScreenDataContext';
import { currentScreenDataActions } from '../../../../reducers/currentScreenDataReducer';
import fetchMethodRequest from '../../../../config/service';
import apiCalls from '../../../../config/apiCalls';
import config from '../../../../config/config';
import ComplianceViewModal from './ComplianceViewModal.jsx';


const SmartScreen = (props) => {
  const { screen } = useParams();
  const params = useParams();
  const booleanOptions = [
    { label: 'True', value: true, color: 'success' },
    { label: 'False', value: false, color: 'danger' },
  ];

  const [rolePermission, setRolePermission] = useState();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [tableFields, setTableFields] = useState([]);
  const [documentData, setDocumentData] = useState(null)
  const [isComplianceViewModalVisible, setComplianceViewModalVisible] = useState(false);


  const { dispatch } = useCurrentScreenDataContext() || { dispatch: () => { } };
  const dataTableRef = useRef(null);

  console.log("Current screen from params:", screen);

  // Re-run whenever the :screen param changes
  useEffect(() => {
    setIsDataLoaded(false);

    let screenPermissions = RolePermissions.screenPermissions('Generated Screens');
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    } else {
      setRolePermission({
        type: { type: "Edit", actions: ['Delete'] },
        actions: ['Delete', 'ExportToCsv', 'BulkUpload'],
      });
    }

    fetchMethodRequest("GET", apiCalls.dynamicScreens).then((res) => {
      const dynamicScreens = res?.dynamicScreens?.[0]?.smartBuilderScreens || [];
      const fields = dynamicScreens.find((item) => item.name === screen)?.fields || [];
      setDataToContext(fields);
    }).catch((err) => {
      console.error(`Error fetching data for screen ${screen}:`, err);
      setDataToContext([]);
    });

  }, [screen]); // re-run on param change

  const setDataToContext = async (fields = tableFields) => {
    fields.forEach(item => {
      const { name, type, show, filter, sortable, label } = item;
      item.show = show ?? true;
      item.header = label?.trim() ? label : name;
      item.filter = filter ?? true;
      item.sortable = sortable ?? true;
      item.displayInSettings = true;
      item.field = name;
      item.key = name;
      item.id = name; // Ensure there's a unique 'id' field for DataTables

      if (type === 'Boolean') {
        item.fieldType = 'dropDown';
        item.options = booleanOptions;
        item.filterElement = booleanOptions
        item.textAlign = 'left';
      } else if (type === 'Date') {
        item.fieldType = type;
        item.dateFormat = config.dateDBFormat;
        item.textAlign = 'left';
      } else if (type === 'String') {
        item.fieldType = 'text';
        item.type = 'text';
        item.textAlign = 'center';
      }
    });


    if (fields.length > 0) {
      fields.unshift(
        {
          textAlign: "center",
          width: 10,
          field: "Check Box",
          label: "Check Box",
          fieldType: "multiple",
          header: "",
          selectionMode: "multiple",
          show: true,
          displayInSettings: true,
          tDisplay: true,
        }, {
        textAlign: 'left',
        width: 70,
        field: "Sno",
        header: "SNo",
        filter: false,
        sortable: false,
        show: true,
        displayInSettings: true,
      }, {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        tDisplay: true,
      },

      );
    }

    dispatch({
      type: currentScreenDataActions.SET_DATA,
      payload: {
        formFields: [],
        tableFields: fields,
      },
    });
    setTableFields(fields);
    setIsDataLoaded(true); // Still set to true to show the table with no data
  };

  const setData = () => {
    let rowData = {};
    if (params.id) {
      rowData['_id'] = JSON.parse(params.id);
      return rowData;
    }
  };
  const complianceViewModalTemplate = ({
    visible,
    onClose,
    data = {}
  }) => {
    if (!visible) return null;

    const { file = {}, extractedData = {}, html } = data;

    return (
      <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
        <div className="bg-white w-[700px] max-h-[90vh] overflow-y-auto rounded-xl p-6 shadow-lg">

          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">Compliance View</h2>
            <button onClick={onClose} className="text-red-500 font-bold">X</button>
          </div>

          {/* File Info */}
          {file && Object.keys(file).length > 0 && (
            <div className="mb-4">
              <h3 className="font-semibold mb-2">File Info</h3>
              <div className="grid grid-cols-2 gap-2 text-sm">
                {Object.entries(file).map(([key, value]) => (
                  <div key={key} className="flex justify-between border-b py-1">
                    <span className="text-gray-600">{key}</span>
                    <span className="font-medium">{String(value)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Extracted Data */}
          {extractedData && Object.keys(extractedData).length > 0 && (
            <div className="mb-4">
              <h3 className="font-semibold mb-2">Extracted Data</h3>
              <div className="grid grid-cols-2 gap-2 text-sm">
                {Object.entries(extractedData).map(([key, value]) => (
                  <div key={key} className="flex justify-between border-b py-1">
                    <span className="text-gray-600">{key}</span>
                    <span className="font-medium">{String(value)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* HTML Preview */}
          {html && (
            <div className="mt-4">
              <h3 className="font-semibold mb-2">Document Preview</h3>
              <div
                className="border p-3 rounded bg-gray-50 text-sm"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          )}

        </div>
      </div>
    );
  };


  const getTableFields = () => {
    return tableFields;
  };

  const actionTypes = [
    {
      name: 'Delete',
      options: [
        {
          label: 'Delete',
          value: 'Delete',
          show: rolePermission?.actions?.includes('Delete') ?? true,
          multiple: true,
        },
      ],
    },
  ];
  const addionalActons = (item, column) => {
    return (
      <i
        className='pi pi-eye fs-6'
        title="Document Info"
        style={{ color: '#17a2b8', }}
        onClick={() => { setDocumentData(item); setComplianceViewModalVisible(true) }}
      />
    )
  }
  const isEditable = rolePermission?.type === 'Edit';
  const actions = rolePermission?.actions || [];
  const permissions = {
    add: isEditable && actions.includes('Add'),
    edit: isEditable && actions.includes('Update'),
    delete: isEditable && actions.includes('Delete'),
    upload: isEditable && actions.includes('BulkUpload'),
    export: isEditable && actions.includes('ExportToCsv'),
    view: isEditable || rolePermission?.type === 'View',
  };

  // Memoize so DataTables doesn't unnecessarily re-render
  const memoizedTableFields = useMemo(
    () => getTableFields(),
    [screen, tableFields]
  );

  // ─── Unrecognised screen param ────────────────────────────────────────
  if (!tableFields?.length && isDataLoaded) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center py-5">
        <h4 className="text-muted">
          Unknown screen: <strong>{screen}</strong>
        </h4>
        <p className="text-muted mt-2">
          Please add a configuration entry for{' '}
          <code>"{screen}"</code> in{' '}
          <code>SmartScreen/config/screenConfig.js</code>.
        </p>
      </div>
    );
  }

  return (
    <>
      {isDataLoaded && (
        <DataTables
          key={screen}
          onRef={(ref) => (dataTableRef.current = ref)}
          {...props}
          getTableFields={() => memoizedTableFields}
          formFields={() => []}
          addRequired={false}
          uploderequired={false}
          editRequired={false}
          deleteRequired={true}
          exportRequired={false}
          sample={false}
          viewRequired={true}
          printRequried={false}
          actionsTypes={actionTypes}
          settingsRequired={false}
          gridRequried={false}
          setData={setData}
          globalSearch={null}
          type={'SmartScreen'}
          displayName={screen}
          routeTo={`smartScreen/${screen}`}
          sideFormLeftOrRight=""
          displayViewOfForm="screen"
          apiResponseKey={'data'}
          apiUrl={`${apiCalls.smartScreens}?screenName=${screen}`}
          selectedId={params.id}
          hasQueryInCall={true}
          deleteUrl={`${apiCalls.smartScreens}/multiDelete?screenName=${screen}`}
          uploadForSmartScreen={true}
          screenName={screen}
          uploadUrl={`${apiCalls.smartScreens}/upload?screenName=${screen}`}
          displayActionsInTable="actions"
          addionalActons={addionalActons}
        />
      )}
      {documentData && <ComplianceViewModal
        data={documentData}      // Your JSON object
        visible={isComplianceViewModalVisible}
        viewModalTemplate={complianceViewModalTemplate}
        // type={SCREEN_NAME_CONSTANTS.INVOICES}
        onDownloadPdf={props?.onDownloadPdf}
        onHide={() => setComplianceViewModalVisible(false)}
      />}
    </>
  );
};

export default SmartScreen;
